import {api, headers} from './api';

const RESOURCE = 'prodi';

export const getsProdi = ()=> api.get(RESOURCE, headers);

export const getsTahun = (prodi)=> api.get(`${RESOURCE}/tahun?prodi=${prodi}`, headers);